import { EntityKind } from "../../utils/entityPaths";
import {
  MERGER_ANSWER_FIELDS,
  MergerAnswers,
  NEEDED_LABELS
} from "./marketAccessFields";

/**
 * The merger's description and Market Access answers as label / value rows, for the sign-off
 * PDFs of both books. The answers stand in for the Market Access lifecycle a merger never ran.
 */
export const mergerSummaryRows = (
  kind: EntityKind,
  mergerDescription: string | null | undefined,
  answers: MergerAnswers | null | undefined
): [string, string][] => [
  ["Merger description", mergerDescription || "N/A"],
  ...MERGER_ANSWER_FIELDS[kind].map((field): [string, string] => {
    const value = answers?.[field.key];
    return [field.label, (value && (NEEDED_LABELS[value] ?? value)) || "N/A"];
  })
];
